import React, {
  useEffect, useState,
} from 'react';

import * as Styles from './Rebuild.styles';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'gatorcomponents';

import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';

import ContentSection from '@/pages/Products/VpsOciDetailPage/commons/ContentSection';

import ModalRebuild from './components/ModalRebuild';

import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';
import { billingAnalytics } from '@/analytics';

const Rebuild = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const vpsOci = useSelector(state => state.vpsOci);
  const { vps, productName } = (vpsOci && vpsOci.data) || {};

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: localeVpsOci } = productDetailsLocale;
  const { rebuild: localeRebuild } = localeVpsOci && localeVpsOci.store;

  const { hostingAndServers: hostingAndServersAnalytics } = billingAnalytics;

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 600;

  useEffect(() => {
    dispatch(vpsOciActions.rebuild.reset());
  }, [dispatch]);

  const handleCloseModalRebuild = () => {
    setShowModal(false);

    hostingAndServersAnalytics.hostingRebuildModalCancelClick(productName);
  };

  const handleOpenModalRebuild = () => {
    setShowModal(true);

    hostingAndServersAnalytics.hostingRebuildConfirmClick(productName);
  };

  if (!vps || Object.keys(vps).length === 0) return null;

  return (
    <ContentSection
      testId="vpsoci-templates-rebuild-container"
      title={localeRebuild.title}
    >
      <Styles.Wrapper>
        <Styles.Description data-testid="vpsoci-templates-rebuild-description">{localeRebuild.description}</Styles.Description>

        <Styles.ButtonWrapper>
          <Button
            label={localeRebuild.button}
            variant="primary"
            size="large"
            width={isMobile ? 'full' : 'fit-content'}
            onClick={handleOpenModalRebuild}
            testId="vpsoci-templates-rebuild-button"
          />
        </Styles.ButtonWrapper>

        {showModal && (
          <ModalRebuild
            onClose={handleCloseModalRebuild}
          />
        )}
      </Styles.Wrapper>
    </ContentSection>
  );
};

export default Rebuild;
